@if (files?.length === 0 && filesDetails?.code!==202 && filesDetails?.code!==404 && fileListVisible) {
  <div class="text-center text-muted u_margin-md-top u_margin-md-bottom">You haven't uploaded any files yet!</div>
}
@if (files?.length > 0 && filesDetails?.code!==202 && filesDetails?.code!==404 && fileListVisible) {
  <div #gridContainer id="storageFilesGrid" class="grid-selector-list grid-selector-list_storage grid-container">
    @for (file of visibleFiles; track trackByFileName($index, file); let index = $index) {
      <div
        (click)="triggerFileClick(file)"
        (keyup.enter)="triggerFileClick(file)"
        tabindex="0"
        [attr.aria-label]="(storageUtilsService.fileIsFolder(file) ? 'Enter folder' : 'Select file') + ' ' + file.name | storageFileName:folderPath"
        class="grid-selector-list-item"
        [class.selected]="file.selected"
        [class.folder]="storageUtilsService.fileIsFolder(file)"
        [class.first-file]="file.isFirstFile"
        [matTooltip]="file.name | storageFileName:folderPath + (file.isThrottled ? ' - This file is being requested too many times and is blocked.' : '')"
        [style.height]="storageUtilsService.fileIsFolder(file) ? '52px' : '186px'">
        <thumbnail-image
          [file]="file"
          [folderPath]="folderPath"
          [index]="index"
          (fileSelect)="triggerFileSelect(file)"
          [index]="index"
        ></thumbnail-image>
        @if (!storageUtilsService.fileIsTrash(file)) {
          <div
            class="menu-container"
            [class.folder]="storageUtilsService.fileIsFolder(file)">
            <operations-menu [operations]="listOperations"
              (operationClick)="handleOperationClick($event, file)" />
          </div>
        }
      </div>
    }
  </div>
}
@if (isEmpty) {
  <empty-state
    [search]="search"
    [isMultipleFilesFoldersSelector]="storageService.isMultipleFilesFoldersSelector()"
    (uploadFiles)="uploadFiles.emit()"
  />
}

